/* ================= DATOS MOCK (TuBus — Municipalidad) =================
   En producción: reemplazar por llamadas al backend (rutas/paradas reales). */

const P104 = [
  [-90.5128, 14.6343], [-90.5128, 14.6372], [-90.5148, 14.6372], [-90.5148, 14.6405],
  [-90.5127, 14.6405], [-90.5127, 14.6436], [-90.5146, 14.6436], [-90.5146, 14.6469],
  [-90.5126, 14.6469], [-90.5126, 14.6502], [-90.5144, 14.6502], [-90.5144, 14.6533],
  [-90.5135, 14.6539]
];
const shift = (p, dx, dy) => p.map(([x, y]) => [x + dx, y + dy]);

export const ROUTES = [
  { id: '104', nombre: 'Ruta 104', color: '#1A237E', origen: 'Centro Cívico', destino: 'San Sebastián',
    path: P104, stopNums: [114, 115, 116, 117, 118, 119, 120, 121, 122, 123],
    buses: [
      { placa: 'C-452BTC', dist: 300, speed: 24 },
      { placa: 'C-871LMN', dist: 2600, speed: 19 }
    ] },
  { id: '7', nombre: 'Ruta 7', color: '#F9A825', origen: 'Parque Colón', destino: 'La Terminal',
    path: shift(P104, 0.0062, -0.0018), stopNums: [201, 202, 203, 204, 205, 206, 207, 208],
    buses: [
      { placa: 'M-238PQR', dist: 900, speed: 26 },
      { placa: 'M-551JKL', dist: 3400, speed: 17 }
    ] },
  { id: '301', nombre: 'Ruta 301', color: '#43A047', origen: 'Zona 1', destino: 'San Pedro',
    path: shift(P104, -0.0055, 0.0032), stopNums: [301, 302, 303, 304, 305, 306, 307],
    buses: [
      { placa: 'P-904XYZ', dist: 1500, speed: 21 }
    ] }
];

/* ================= HELPERS GEODÉSICOS ================= */
const toRad = d => d * Math.PI / 180;

function segLen(a, b) {
  const dx = (a[0] - b[0]) * 111320 * Math.cos(toRad((a[1] + b[1]) / 2));
  const dy = (a[1] - b[1]) * 110540;
  return Math.hypot(dx, dy);
}

export function cumul(pts) {
  const c = [0];
  for (let i = 1; i < pts.length; i++) c.push(c[i - 1] + segLen(pts[i - 1], pts[i]));
  return c;
}

/* Punto a "d" metros del inicio del path + rumbo (radianes, 0=norte) */
export function pointAt(pts, c, d) {
  const total = c[c.length - 1];
  d = ((d % total) + total) % total;
  let i = 1;
  while (i < c.length - 1 && c[i] < d) i++;
  const t = (d - c[i - 1]) / (c[i] - c[i - 1] || 1);
  const x = pts[i - 1][0] + (pts[i][0] - pts[i - 1][0]) * t;
  const y = pts[i - 1][1] + (pts[i][1] - pts[i - 1][1]) * t;
  const brg = Math.atan2(pts[i][0] - pts[i - 1][0], pts[i][1] - pts[i - 1][1]);
  return { coord: [x, y], brg };
}

/* Geometría precalculada */
ROUTES.forEach(r => {
  r.cum = cumul(r.path);
  r.cumTot = r.cum[r.cum.length - 1];
});

/* ================= PERSISTENCIA (LocalStorage) =================
   Simula el backend: los buses "avanzan" aunque la app esté cerrada. */
const LS_KEY = 'tubus_mock_v1';

export function saveState(routes) {
  const o = { ts: Date.now(), buses: {} };
  routes.forEach(r => r.buses.forEach(b => { o.buses[b.placa] = { d: Math.round(b.dist) }; }));
  localStorage.setItem(LS_KEY, JSON.stringify(o));
}

export function loadState(routes) {
  try {
    const o = JSON.parse(localStorage.getItem(LS_KEY) || 'null');
    if (!o) return;
    const elapsed = Math.min((Date.now() - o.ts) / 1000, 7200); // máx 2h "offline"
    routes.forEach(r => r.buses.forEach(b => {
      const s = o.buses[b.placa];
      if (s) b.dist = s.d + elapsed * (b.speed / 3.6) * 0.6;
    }));
  } catch (e) { /* ignore */ }
}
